var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LogoSvg',{staticClass:"logo",style:({ width: `${_vm.width}px`, height: `${_vm.height}px` }),attrs:{"alt":"Yoreferee Booking Engine"}})
}
var staticRenderFns = []

export { render, staticRenderFns }